export const enum MyAccountToggleSaveButtonInteractionEvent {
  /**
   * Clicked on save button
   */
  save = 'save',

  /**
   * Clicked on unsave button
   */
  unsave = 'unsave',

  /**
   * Clicked to close sign in popup
   */
  closeSignInPopup = 'closeSignInPopup',

  /**
   * Triggered to opening sign up
   */
  openSignInPopup = 'openSignInPopup',
}
